export default {
  videoFile: {
    rePlayVideoBtn: '再生をリスタート',
    playVideoBtn: '動画の再生',
    stopVideoBtn: '動画の一時停止',
  },
  videoLoop: {
    loopNumber: '再生回数',
    playEndFrame: '最終フレームを維持',
    title: '再生',
    autoPlay: '自動再生',
    autoPlayText: '起動時に自動再生',
    loop: 'ループ',
  },
  videoSound: {
    videoSound: 'ビデオ音声',
    muteSound: 'ミュート',
    title: '音声',
  },
  videoEditor: {
    argumentsAreEmpty: 'URLとonCropは必須パラメーターです',
  },
}
